import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { AtividadeTipoPipeModule } from '../pipes';
import { AtividadeTipoSelectComponent } from './atividade-tipo-select.component';

@NgModule({
    imports: [
        SharedModule,
        AtividadeTipoPipeModule
    ],
    declarations: [
        AtividadeTipoSelectComponent
    ],
    exports: [
        AtividadeTipoSelectComponent
    ]
})
export class AtividadeTipoSelectModule { }
